import { render } from "./BienPage.vue?vue&type=template&id=3ef1717c"
import script from "./BienPage.vue?vue&type=script&lang=js"
export * from "./BienPage.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__